import type {Rotation} from '../../../../packages/domain/src/types';
export type Role = 'S'|'OH1'|'OH2'|'MB1'|'MB2'|'OPP'|'L';
export type Position = 'S'|'OH'|'MB'|'OPP'|'L'|'ALL';
export type Camera = 'broadcast'|'topDown'|'behindServer'|'coach'|'firstPerson';
export type Phase = 'base'|'serve'|'switch'|'defence';
export type Moment = 'base'|'receive'|'serve'|'switch';
export type Locale = 'he'|'en';
/** Optional custom names per role, shown wherever a role label would appear. */
export type PlayerNames = Partial<Record<Role,string>>;
export interface AppState {
 screen:'title'|'court';position:Position;selectedRole:Role|null;rotation:Rotation;weServe:boolean;phase:Phase;camera:Camera;
 playbackRate:number;appearance:'dark'|'light';locale:Locale;libero:boolean;netHeight:'women'|'men';muted:boolean;showZoneNumbers:boolean;showOpponents:boolean;quality:'low'|'high';reducedMotion:boolean;
 cameraReset?:number;learningPlayback?:boolean;attackZone?:2|3|4;showDefenceCoverage?:boolean;
 playerNames:PlayerNames;
}
export interface SceneApi { feedback?(kind:'selection'|'move'):void; play():void; playAttack?():void; cancel():void;seek(seconds:number):void;togglePause():void; readonly running:boolean;readonly paused:boolean;readonly time:number; }
/** Okabe-Ito adapted: colour-blind-safe hues, one per role family, with the libero in the odd-shirt yellow. */
export const ROLE_COLORS:Record<Role,string>={S:'#56B4E9',OH1:'#2FBF93',OH2:'#2FBF93',MB1:'#CC79A7',MB2:'#CC79A7',OPP:'#E8703A',L:'#F0E442'};
/** Dark lettering on every role colour, and white for the selected player so "you" never shares a hue with a role. */
export const BADGE_INK='#142029';
export const SELECTION_COLOR='#f4f7f5';
export const NUMBERS:Record<Role,number>={S:1,OH1:7,OH2:10,MB1:4,MB2:12,OPP:9,L:3};
